import React from "react"
import { Link } from "gatsby"

const Button = ({ label, label_secondary, link }) => {
  const internal = /^\/(?!\/)/.test(link)
  const labels = (
    <>
      <span className="button__label--primary">{label}</span>
      <span className="button__label--secondary">{label_secondary}</span>
    </>
  )

  if (internal) {
    return (
      <Link to={link} className="button">
        {labels}
      </Link>
    )
  } else {
    return (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="button"
      >
        {labels}
      </a>
    )
  }
}

export default Button
